import {initializeApp, getApps, FirebaseApp} from "firebase/app";
import {getAuth, Auth} from "firebase/auth";
import {getFirestore, Firestore} from "firebase/firestore";
import {getFunctions, Functions} from "firebase/functions";

// Firebase configuration - get from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "gam-project-lj1-bl5-upj.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gam-project-lj1-bl5-upj",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gam-project-lj1-bl5-upj.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Check if Firebase is properly configured
const isFirebaseConfigured = !!(firebaseConfig.apiKey && firebaseConfig.appId);

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;
let functions: Functions | null = null;

// Initialize Firebase only if configured
try {
  if (isFirebaseConfigured) {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
    auth = getAuth(app);
    db = getFirestore(app);
    functions = getFunctions(app);
  } else {
    console.warn("Firebase not configured. Please set environment variables.");
  }
} catch (error) {
  console.error("Firebase initialization error:", error);
}

// Export with null checks - components should check these before use
export {auth, db, functions};
export default app;

